/** Routes where the coach FAB and floating bar should not appear. */
const PUBLIC_ROUTES = new Set([
  '/', '/welcome', '/auth', '/about', '/pricing', '/magic',
  '/nps-feedback', '/testimonial', '/terms', '/privacy',
  '/data-retention', '/dpa', '/privacy/b2b', '/terms/teams',
]);

export function isCoachHiddenRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.has(pathname) || pathname.startsWith('/admin');
}
